export default "__VITE_ASSET__kODt1DNY__"